import { render, staticRenderFns } from "./targetUserPic.vue?vue&type=template&id=765bdb16&scoped=true&"
import script from "./targetUserPic.vue?vue&type=script&lang=js&"
export * from "./targetUserPic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765bdb16",
  null
  
)

export default component.exports